import JSInstallWeb from "../../../../contents/docs/integrate/_snippets/install-web.mdx";
import * as React from 'react';
export default {
  JSInstallWeb,
  React
};